import SendLocationWindow from './SendLocationWindow';
export default SendLocationWindow;
